import { Box, Typography } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

import { PrimaryButton } from '@/components';
import { Screens } from '@/routes';

export const Error404Page = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                width: '100%',
                flexDirection: 'column',
                mt: 20
            }}
        >
            <Typography variant="h1" sx={{ color: '#434e59', fontSize: '8.2rem', lineHeight: '7.1rem' }}>
                404
            </Typography>
            <Typography variant="h3" sx={{ my: 3, whiteSpace: 'nowrap', fontWeight: 500 }}>
                Sorry, the page you visited does not exist
            </Typography>
            <Box sx={{ width: '100%' }} component={Link} to={Screens.Dashboard}>
                <PrimaryButton title="Back To Home" />
            </Box>
        </Box>
    );
};
